<template>
  <VisibleModal />
  <div class="modal__overlay">
    <div class="modal" @click.stop="''" :style="[successMessage ? {'padding-top':'16px'} : '']">
      <div class="mod-header">
        <h3><template
          v-if="!successMessage && !errorMessage && !loading"
          ><div class="icon-help"><i class="material-icons">help</i></div> {{ $t('helpModal.NEED_HELP') }} </template></h3>
        <i class="material-icons close" @click.stop="closeHelpModal()">close</i>
      </div>
      <template
        v-if="!successMessage && !errorMessage && !loading"
      >
        <!-- <h4>{{ $t('helpModal.SEND_US_YOUR_QUERY') }}</h4> -->
        <h4 v-html="$t('helpModal.SEND_US_YOUR_QUERY')"></h4>
        <!-- <textarea v-model="consultation" :placeholder="$t('helpModal.WRITE_YOUR_QUERY')"></textarea> -->
        <!-- <div class="modal__buttons">
          <button @click.stop="closeHelpModal()">{{$t('global.CANCEL')}}</button>
          <button @click.stop="send()">{{ $t('helpModal.SEND') }}</button>
        </div> -->
      </template>
      <template v-if="loading">
        <Loader />
      </template>
      <template v-if="successMessage">
      <div class="success-message">
        <div class="icon-success"><i class="material-icons">done_all</i></div>
        <h3>{{ $t('helpModal.THANK_YOU') }}</h3>
        <h4>{{ $t('helpModal.RECEIVED_SUCCESSFULLY') }}</h4>
        <h4>{{ $t('helpModal.WILL_CONTACT_SOON') }}</h4>
      </div>
    </template>
    <template v-if="errorMessage">
      <div class="error-message">
        <div class="icon-error"><i class="material-icons">close</i></div>
        <h3>{{ $t('helpModal.ERROR_OCCURRED') }}</h3>
        <h4>{{ $t('helpModal.PLEASE_TRY_AGAIN_LATER') }}</h4>
      </div>
    </template>
    </div>
  </div>
</template>

<script>
//import { inject, computed } from "@vue/runtime-core";
//import { useRouter } from "vue-router";
import { ref } from 'vue';
import { useStore } from "vuex";
import VisibleModal from '@/components/VisibleModal.vue';
import Loader from '@/components/Loader.vue';

export default {
    components: {
        VisibleModal,
        Loader
    },
  setup(_, { emit }) {
    //const router = useRouter();
    const store = useStore();
    const consultation = ref('');
    const successMessage = ref(false);
    const errorMessage = ref(false);
    const loading = ref(false);



    function closeHelpModal(){
      emit('closeHelpModal');
    }

    async function send() {
      loading.value = true;
      try {
        await store.dispatch('stuff_postConsultation', { consultation: consultation.value });
        successMessage.value = true;
        errorMessage.value = false;
      } catch (error) {
        console.error(error);
        successMessage.value = false;
        errorMessage.value = true;
      }
      loading.value = false;
    }


    return {
      consultation,
      closeHelpModal,
      send,
      successMessage,
      errorMessage,
      loading
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/main.scss";

@mixin icon-w-bg {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 9px;
  border-radius: 100%;
  background: map-get($primary, onMediumEmphasis);
  .material-icons{
    color: $green;
  }
}
.modal{
  margin-top: -5vh;
  width: 96%;
  max-width: 560px;
  padding: 40px;
  padding-right: 36px;
  background: #fff;
  border-radius: 10px;
  .mod-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    h3{
      display: flex;
      align-items: center;
      gap: 14px;
      font-weight: 700;
      font-size: 17px;
      .icon-help{
        @include icon-w-bg;
        .material-icons{
          font-size: 20px;
        }
      }
    }
    .close{
      font-size: 22px;
      font-weight: 500;
      cursor: pointer;
    }
  }
  h4{
    margin: 8px 0;
    font-size: 14px;
    color: $black;
    font-weight: 500;
    //text-align: center;
  }
  textarea{
    width: 100%;
    height: 140px;
    padding: 6px;
    margin-top: 4px;
    border-radius: 4px;
    resize: vertical;
    background: $lightgray;
    outline: none;
    border: none;
    &::placeholder{
      padding: 18px 16px;
      font-style: italic;
    }
    &:focus{
      outline: none;
      border: 1px solid;
    }
  }
  &__buttons{
    margin-top: 20px;
    justify-content: flex-end;
    gap: 16px;
    button{
      padding: 8px 20px;
      font-size: 14px;
      font-weight: 500;
      &:first-child{
        color: $green;
        font-weight: 600;
      }
      &:last-child{
        background: $green;
        color: #fff;
      }
    }
  }
  .success-message{
    @include flex-column;
    .icon-success{
      @include icon-w-bg;
      padding: 10px;
    }
    h3{
      margin: 12px 0;
    }
    h4{
      margin: 0;
      text-align: center;
    }
  }
  .error-message{
    @include flex-column;
    .icon-error{
      @include icon-w-bg;
      padding: 10px;
      .material-icons{
        color: $red;
      }
    }
    h3{
      margin: 12px 0;
    }
    h4{
      margin: 0;
      text-align: center;
    }
  }
}

.loader__container {
  height: 180px;
}

</style>
<style lang="scss">
@import "@/styles/main.scss";

.phone-number {
  color: $green;
  font-weight: 600;
}
</style>